<script>
    import { onMount } from 'svelte';
    import MapLoading from '../../components/common/Loading/MapLoading.svelte';
    import Area from '../../models/Area/Area';

    export let areaId = null;
    export let customClass = '';

    let map;
    let mapContainer;
    let loadingMap = true;
    let mapDataReady = false;
    export let latitude = 46.4982953;
    export let longitude = 11.3547582;
    export let zoom = 13;

    let [dataArea, loadingArea, errorArea] = [null, false, null];

    if (areaId) {
      [dataArea, loadingArea, errorArea] = Area.get(areaId);
    }

    $: {
        if (areaId && $dataArea && $dataArea.id) {
            if ($dataArea.mapZoom) {
                zoom = $dataArea.mapZoom;
            }
            if ($dataArea.mapLatitude && $dataArea.mapLongitude) {
                latitude = $dataArea.mapLatitude;
                longitude = $dataArea.mapLongitude;
            }
        }
        mapDataReady = true;
    }

    onMount(() => {
        let initAttempts = 0;
        const maxAttempts = 5;

        const initMap = () => {
            if (mapDataReady && mapContainer) {
                try {
                    loadingMap = false;

                    map = L.map(mapContainer, { zoomControl: false, scrollWheelZoom: false }, {
                        renderer: L.canvas()
                    });

                    map.setView([latitude, longitude], zoom);

                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        maxZoom: zoom,
                    }).addTo(map);
                    
                } catch (error) {
                    console.error("Error initializing map:", error);
                    loadingMap = false;
                }
            } else {
                initAttempts++;
                if (initAttempts < maxAttempts) {
                    setTimeout(initMap, 2000);
                } else {
                    console.error("Max attempts reached. Unable to initialize map.");
                    loadingMap = false;
                }
            }
        };
        initMap();
    });
</script>

<style>
    #map {
        height: 500px;
        width: 100%;
    }
</style>

{#if loadingMap}
    <MapLoading />
{/if}

<div bind:this={mapContainer} id="map" class={customClass}></div>
